<template>
  <nav class="nav">
    <div class="logo">
      <div class="logo-ico">
        <img src="/logo-miner.png" alt="金狗人生 logo">
      </div>
      <div>
        <div class="logo-name">金狗人生 <span class="logo-fire">🔥🔥🔥</span></div>
        <div class="logo-chain">BSC · $金狗人生</div>
      </div>
    </div>
    <button class="wbtn" @click="$emit('connect')">
      <span class="dot" />
      {{ connected ? walletLabel : '连接钱包' }}
    </button>
  </nav>
</template>

<script>
import { showAccount } from '../utils/utils'

export default {
  name: 'TopNav',
  props: {
    connected: {
      type: Boolean,
      default: false,
    },
    account: {
      type: String,
      default: '',
    },
  },
  computed: {
    walletLabel() {
      return this.account ? showAccount(this.account) : '连接钱包'
    },
  },
}
</script>

<style scoped>
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: rgba(12, 6, 0, 0.98);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 200;
  backdrop-filter: blur(20px);
}

.logo {
  display: flex;
  align-items: center;
  gap: 9px;
}

.logo-ico {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 2px solid var(--gold-d);
  background: #1a1000;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 0 16px rgba(245, 200, 66, 0.12);
}

.logo-ico img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-name {
  font-family: 'Orbitron', monospace;
  font-size: 13px;
  font-weight: 900;
  background: linear-gradient(135deg, var(--gold-l), var(--amber));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
}

.logo-fire {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-left: 4px;
  background: none;
  -webkit-background-clip: border-box;
  -webkit-text-fill-color: initial;
  font-size: 11px;
  letter-spacing: 0;
  vertical-align: middle;
}

.logo-chain {
  font-size: 9px;
  color: var(--muted);
  letter-spacing: 0.5px;
  margin-top: 1px;
}

.wbtn {
  background: var(--surface);
  border: 1px solid var(--gold-d);
  color: var(--gold);
  padding: 7px 13px;
  border-radius: 20px;
  font-size: 11px;
  font-family: 'Orbitron', monospace;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--green);
  animation: blink 2s infinite;
}
</style>
